import { Snackbar, ISnackbarProps } from "./Snackbar";

export type { ISnackbarProps };
export default Snackbar;
